interface IGetTooltipPositionParams {
    triggerRect: DOMRect;
    tooltipSize: {
        width: number;
        height: number;
    };
    viewport: {
        width: number;
        height: number;
    };
    offsetTop?: number;
    offsetLeft?: number;
    padding?: number;
}

export function getTooltipPosition({
    triggerRect,
    tooltipSize,
    viewport,
    offsetTop,
    offsetLeft,
    padding = 8,
}: IGetTooltipPositionParams): {
        top: number;
        left: number;
    } {
    let top = triggerRect.top + (offsetTop ?? triggerRect.height + 4);
    let left = triggerRect.left + (offsetLeft ?? 0);

    if (left + tooltipSize.width > viewport.width - padding) {
        left = viewport.width - padding - tooltipSize.width;
    }
    if (left < padding) {
        left = padding;
    }
    if (top + tooltipSize.height > viewport.height - padding) {
        const topAbove = triggerRect.top - tooltipSize.height - 4;

        top = topAbove < padding ? padding : topAbove;
    }

    return {
        top,
        left,
    };
}
